import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3e5acdfc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3e5acdfc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5acdfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e5acdfc')) {
      api.createRecord('3e5acdfc', component.options)
    } else {
      api.reload('3e5acdfc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3e5acdfc&scoped=true", function () {
      api.rerender('3e5acdfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/senate/lesson-student/index.vue"
export default component.exports